import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { FieldArray, reduxForm } from "redux-form";
import AppWrapper from "../../Common/AppWrapper/index.jsx";
import { GeneExpressionIdentifier } from "./GeneExpressionIdentifier.jsx";
import GeneExpressionDescription from "./GeneExpression-Description.jsx";

import * as assayActions from "../../../actions/assays.js";
import "../AssayCreate.scss";
import Loading from "../../Common/Misc/Loading.jsx";

export class GeneExpressionForm extends React.Component {
  constructor(props) {
    super(props);
  }
  componentWillUnmount() {
    const { actions } = this.props;
    actions.clearMessage();
  }

  onSubmit = (values, dispatch) => {
    return dispatch(assayActions.processGetNewAssays(values));
  };
  render() {
    const {
      handleSubmit,
      pristine,
      submitting,
      formObj,
      submittedValues,
      pageLoading,
      validatedAssayDetails,
    } = this.props;
    if (pageLoading) {
      return (
        <div id="geneexpression-form">
          <Loading isLoading={pageLoading} />
        </div>
      );
    }
    return (
      <div id="geneexpression-form">
        <div className="row target-by">
          <div className="col">
            <strong>Enter Target by:&nbsp;</strong>
            <div className="form-check form-check-inline">
              <label className="form-check-label" htmlFor="inlineCheckbox1">
                Identifier
              </label>
            </div>
          </div>
        </div>
        <FieldArray
          name="geneExpressionIdentifier"
          custom={this.props}
          component={GeneExpressionIdentifier}
          submittedValues={submittedValues.entries}
        />

        <div className="row">
          <div className="col">
            <button
              type="button"
              className="btn-submit float-right"
              disabled={pristine || submitting}
              onClick={handleSubmit(this.onSubmit.bind(this))}
            >
              SUBMIT
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const epochDate = new Date().getTime();

const stateToProps = (state) => ({
  formObj: state && state.form["frmGeneExpression"],
  submittedValues: (state.assays && state.assays.apiPayload) || {},
  initialValues: {
    applicationType: "GeneExpression",
    targetBy: "identifier",
    geneExpressionIdentifier: [
      {
        genome: "Homo sapiens",
        fluorophores: "FAM",
        createdAt: epochDate,
        assayType: "Gene",
        uuid: "",
      },
    ],
  },
  validatedAssayDetails:
    (state.assays &&
      state.assays.validatedAssayDetails &&
      state.assays.validatedAssayDetails.data) ||
    {},
  pageLoading: (state.assays && state.assays.pageLoading) || false,
});

const dispatchToProps = (dispatch) => ({
  actions: bindActionCreators(assayActions, dispatch),
});

GeneExpressionForm = reduxForm({
  form: "frmGeneExpression",
})(GeneExpressionForm);

GeneExpressionForm = connect(stateToProps, dispatchToProps)(GeneExpressionForm);

GeneExpressionForm.propTypes = {
  formObj: PropTypes.object,
  handleSubmit: PropTypes.func,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
  actions: PropTypes.object,
  validatedAssayDetails: PropTypes.object,
};

const GeneExpression = () => {
  return (
    <AppWrapper
      id="geneexpression"
      pageTitle="Gene Expression"
      pageKeywords="Gene Expression, design engine, custom assays"
      pageDescription="ddPCR Gene Expression Assays enable accurate quantification of small fold changes in gene expression. ddPCR Gene Expression Assays are available as probe or EvaGreen Assays."
    >
      <div id="bg">
        <div id="bg-inner"></div>
      </div>
      <div className="container main-content">
        <div className="hero">
          <h2 className="h4">ASSAY DESIGN ENGINE</h2>
          <h1>Gene Expression</h1>
        </div>

        <GeneExpressionForm />
        <GeneExpressionDescription />
      </div>
    </AppWrapper>
  );
};

export default GeneExpression;
